import reduxApi from 'redux-api';
import { tokenOptions, adapterJquery, baseApiUrl } from './ApiHelpers';


export default reduxApi({
  me: {
    url: `${baseApiUrl}/v1/advertisers/me`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  meUpdate: {
    url: `${baseApiUrl}/v1/advertisers/me`,
    virtual: true,
    helpers: {
      post(data) {
        return [{}, {
          data,
          method: 'PUT'
        }];
      }
    }
  },
  accounts: {
    url: `${baseApiUrl}/v1/advertiser/accounts`,
    options: {
      method: 'GET'
    }
  },
  accountCreate: {
    url: `${baseApiUrl}/v1/advertiser/accounts`,
    virtual: true,
    helpers: {
      post(data) {
        return [{}, {
          data,
          method: 'POST'
        }];
      }
    }
  },
  reports: {
    url: `${baseApiUrl}/v1/advertiser/accounts/:id/reports`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  reportsSummary: {
    url: `${baseApiUrl}/v1/advertiser/accounts/:id/reports_summary`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  account: {
    url: `${baseApiUrl}/v1/advertiser/accounts/:id`,
    helpers: {
      get(params) {
        return [params, {
          method: 'GET'
        }];
      }
    }
  },
  accountUpdate: {
    url: `${baseApiUrl}/v1/advertiser/accounts/:id`,
    virtual: true,
    helpers: {
      post(id, data) {
        return [{ id }, {
          data,
          method: 'PUT'
        }];
      }
    }
  },
  accountDelete: {
    url: `${baseApiUrl}/v1/advertiser/accounts/:id`,
    virtual: true,
    helpers: {
      post(id) {
        return [{ id }, {
           method: 'DELETE'
        }];
      }
    }
  },
  pixel: {
    url: `${baseApiUrl}/v1/advertiser/pixels`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  jobs: {
    url: `${baseApiUrl}/v1/advertiser/jobs`,
    urlOptions: {
      arrayFormat: 'brackets'
    },
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  bulkJobsCreate: {
    url: `${baseApiUrl}/v1/advertiser/jobs/bulk`,
    virtual: true,
    helpers: {
     post(params, data) {
        return [params, {
          data,
           method: 'POST'
        }];
      }
    }
  },
  jobUpdate: {
    url: `${baseApiUrl}/v1/advertiser/jobs/:id`,
    virtual: true,
    helpers: {
      patch(account_id, data) {
        return [account_id, {
          data,
          method: 'PATCH'
        }];
      }
    }
  },
  jobDelete: {
    url: `${baseApiUrl}/v1/advertiser/jobs/:id`,
    virtual: true,
    helpers: {
      delete(account_id, data) {
        return [account_id, {
          data,
          method: 'DELETE'
        }];
      }
    }
  },
  bulkJobsDelete: {
    url: `${baseApiUrl}/v1/advertiser/jobs/bulk`,
    virtual: true,
    helpers: {
      delete(account_id, data) {
        return [account_id, {
          data,
          method: 'DELETE'
        }];
      }
    }
  },
  jobsPaginate: {
    url: `${baseApiUrl}/v1/advertiser/jobs`,
    urlOptions: {
      arrayFormat: 'brackets'
    },
    virtual: true,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  ads: {
    url: `${baseApiUrl}/v1/advertiser/ads`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  adCreate: {
    url: `${baseApiUrl}/v1/advertiser/ads`,
    virtual: true,
    helpers: {
      post(data) {
        return [{}, {
          data,
          method: 'POST'
        }];
      },
      postMultiple(data, cb, rcb) {
        return [{}, {
          data,
          method: 'POST',
          cb,
          rcb
        }];
      }
    }
  },
  adUpdate: {
    url: `${baseApiUrl}/v1/advertiser/ads/:id`,
    virtual: true,
    helpers: {
      patch(id, data) {
        return [{ id }, {
          data,
          method: 'PATCH'
        }];
      }
    }
  },
  adDelete: {
    url: `${baseApiUrl}/v1/advertiser/ads/:id`,
    virtual: true,
    helpers: {
      delete(id, data) {
        return [{ id }, {
          data,
          method: 'DELETE'
        }];
      }
    }
  },
  adReports: {
    url: `${baseApiUrl}/v1/advertiser/ads/reports`,
    urlOptions: {
      arrayFormat: 'brackets'
    },
    helpers: {
      get(params) {
        return [params, {
          method: 'GET'
        }];
      }
    }
  },
  campaigns: {
    url: `${baseApiUrl}/v1/advertiser/campaigns`,
    urlOptions: {
      arrayFormat: 'brackets'
    },
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  standardCampaign: {
    url: `${baseApiUrl}/v1/advertiser/self_serve_campaigns/:id`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  standardCampaigns: {
    url: `${baseApiUrl}/v1/advertiser/self_serve_campaigns`,
    helpers: {
      get(params) {
        return [params, {
           method: 'GET'
        }];
      }
    }
  },
  standardCampaignCreate: {
    url: `${baseApiUrl}/v1/advertiser/self_serve_campaigns`,
    virtual: true,
    helpers: {
      post(params, data) {
        return [params, {
          data,
          method: 'POST'
        }];
      }
    }
  },
  standardCampaignUpdate: {
    url: `${baseApiUrl}/v1/advertiser/self_serve_campaigns/:id`,
    virtual: true,
    helpers: {
      patch(account_id, id, data) {
        return [{ account_id, id }, {
          data,
          method: 'PATCH'
        }];
      }
    }
  },
  standardCampaignDelete: {
    url: `${baseApiUrl}/v1/advertiser/self_serve_campaigns/:id`,
    virtual: true,
    helpers: {
      delete(id, data) {
        return [{ id }, {
          data,
          method: 'DELETE'
        }];
      }
    }
  },
  invoices: {
    url: `${baseApiUrl}/v1/advertiser/accounts/invoices`,
    helpers: {
      get(params) {
        return [params, {
          method: 'GET'
        }];
      }
    }
  },
  payInvoices: {
    url: `${baseApiUrl}/v1/advertiser/accounts/pay_invoices`,
    helpers: {
      get(params) {
        return [params, {
          method: 'GET'
        }];
      }
    }
  },
  customers: {
    url: `${baseApiUrl}/v1/advertiser/customers`,
    options: {
      method: 'GET'
    }
  },
  cards: {
    url: `${baseApiUrl}/v1/advertiser/cards`,
    helpers: {
      get(params) {
        return [params, {
          method: 'GET'
        }];
      }
    }
  },
  cardCreate: {
    url: `${baseApiUrl}/v1/advertiser/cards/:card_id`,
    virtual: true,
    helpers: {
      post(params) {
        return [params, {
          method: 'POST'
        }];
      }
    }
  },
  cardUpdate: {
    url: `${baseApiUrl}/v1/advertiser/cards/:card_id`,
    virtual: true,
    helpers: {
      patch(card_id, params) {
        return [{ card_id, ...params }, {
          method: 'PATCH'
        }];
      }
    }
  },
  cardDelete: {
    url: `${baseApiUrl}/v1/advertiser/cards/:card_id`,
    virtual: true,
    helpers: {
      post(params) {
        return [params, {
          method: 'DELETE'
        }];
      }
    }
  },
  campaignDelete: {
    url: `${baseApiUrl}/v1/advertiser/campaigns/:id`,
    virtual: true,
    helpers: {
      post(account_id, id) {
        return [{ account_id, id }, {
           method: 'DELETE'
        }];
      }
    }
  },
  campaignReport: {
    url: `${baseApiUrl}/v1/advertiser/campaigns/reports`,
    urlOptions: {
      arrayFormat: 'brackets'
    },
    helpers: {
      get(params) {
        return [params, {
          method: 'GET'
        }];
      }
    }
  },
  campaignReports: {
    url: `${baseApiUrl}/v1/advertiser/campaigns/reports`,
    urlOptions: {
      arrayFormat: 'brackets'
    },
    helpers: {
      get(params) {
        return [params, {
          method: 'GET'
        }];
      }
    }
  }
}).use('options', tokenOptions).use('fetch', adapterJquery);
